import { createLabeledMessages } from '../../../messageUtils';
const person = {
    firstName: 'jméno',
    surname: 'příjmení',
    birthNumber: 'rodné číslo',
    birthNumber_short: 'RČ',
    birthDate: 'datum narození',
    ico: 'IČO',
    type: 'typ osoby',
    degreeBefore: 'titul před',
    degreeAfter: 'titul za',
    phone: 'pevná linka',
    mobile: 'mobilní telefon',
    email: 'e-mail',
    logon: 'přihlašovací jméno',
    foreigner: 'cizinec',
    nationality: 'státní příslušnost',
    count: 'počet osob'
};
export default Object.assign({}, person, createLabeledMessages(person));
